var _g, _g2, _g3, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 39,
    viewBox: "0 0 116 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_diii_141_259)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 16,
    fill: "white",
    fillOpacity: 0.2,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 15.5948,
    stroke: "white",
    strokeOpacity: 0.11,
    strokeWidth: 0.810371,
    shapeRendering: "crispEdges"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_df_141_259)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 11.1426,
    fill: "url(#paint0_linear_141_259)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 9.1426,
    stroke: "url(#paint1_linear_141_259)",
    strokeWidth: 4,
    shapeRendering: "crispEdges"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dfn_141_259)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 11.1426,
    fill: "url(#paint2_linear_141_259)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 9.1426,
    stroke: "url(#paint3_linear_141_259)",
    strokeWidth: 4,
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.146 11.2737C51.3023 11.2737 51.4065 11.3193 51.4586 11.4105C51.5237 11.4886 51.5563 11.6124 51.5563 11.7817L51.5368 12.9343C51.5368 13.1427 51.5498 13.4422 51.5758 13.8329C51.6279 14.3408 51.7256 14.953 51.8689 15.6693V15.767C51.8689 15.9102 51.8233 15.9819 51.7321 15.9819C51.68 15.9819 51.641 15.9623 51.6149 15.9232C51.5889 15.8711 51.5563 15.793 51.5172 15.6888C51.2828 14.5818 51.0484 13.7483 50.8139 13.1882C50.5925 12.6282 50.2995 12.231 49.9348 11.9966C49.5702 11.7621 49.0687 11.6449 48.4306 11.6449H45.8714C45.5588 11.6449 45.3244 11.7361 45.1681 11.9184C45.0118 12.1008 44.9337 12.3352 44.9337 12.6217V18.248C44.9337 18.4954 45.0118 18.6973 45.1681 18.8536C45.3244 19.0099 45.5263 19.088 45.7737 19.088H47.8445C48.5087 19.088 48.9515 18.9252 49.1729 18.5996C49.4074 18.274 49.5246 17.7726 49.5246 17.0954C49.5246 16.9391 49.5702 16.861 49.6613 16.861C49.7265 16.861 49.7655 16.8805 49.7785 16.9196C49.8046 16.9586 49.8176 17.0238 49.8176 17.1149C49.8176 17.2973 49.8046 17.6229 49.7785 18.0917C49.7395 18.4564 49.7199 18.8341 49.7199 19.2248C49.7199 19.5894 49.7395 19.9606 49.7785 20.3383C49.8046 20.8072 49.8176 21.1458 49.8176 21.3542C49.8176 21.4453 49.8046 21.5105 49.7785 21.5495C49.7655 21.5886 49.7265 21.6081 49.6613 21.6081C49.5702 21.6081 49.5246 21.53 49.5246 21.3737C49.5246 20.6965 49.4074 20.1951 49.1729 19.8695C48.9515 19.5439 48.5087 19.3811 47.8445 19.3811H45.7737C45.5263 19.3811 45.3244 19.4592 45.1681 19.6155C45.0118 19.7718 44.9337 19.9671 44.9337 20.2016V24.9097C44.9337 25.652 45.103 26.1535 45.4416 26.4139C45.7933 26.6614 46.3272 26.7851 47.0435 26.7851C47.1347 26.7851 47.1933 26.7981 47.2194 26.8242C47.2584 26.8372 47.278 26.8763 47.278 26.9414C47.278 27.0065 47.2584 27.0456 47.2194 27.0586C47.1803 27.0847 47.1152 27.0977 47.024 27.0977C46.5552 27.0977 46.0733 27.0781 45.5784 27.0391C44.9793 27.013 44.5755 27 44.3671 27H43.7811C43.5857 27 43.2015 27.013 42.6285 27.0391C42.1596 27.0781 41.7038 27.0977 41.261 27.0977C41.1568 27.0977 41.0917 27.0847 41.0656 27.0586C41.0265 27.0326 41.007 26.987 41.007 26.9219C41.007 26.8177 41.0851 26.7656 41.2414 26.7656C41.9187 26.7656 42.4201 26.6418 42.7457 26.3944C43.0713 26.1469 43.2341 25.652 43.2341 24.9097V13.4617C43.2341 12.7194 43.0713 12.2245 42.7457 11.977C42.4201 11.7165 41.9187 11.5863 41.2414 11.5863C41.1503 11.5863 41.0917 11.5733 41.0656 11.5472C41.0265 11.5212 41.007 11.4821 41.007 11.43C41.007 11.3649 41.0265 11.3258 41.0656 11.3128C41.1047 11.2868 41.1698 11.2737 41.261 11.2737C41.7038 11.2737 42.1596 11.2933 42.6285 11.3323C43.2015 11.3584 43.5857 11.3714 43.7811 11.3714H49.505C49.6744 11.3714 50.052 11.3519 50.6381 11.3128C50.8986 11.2868 51.0679 11.2737 51.146 11.2737ZM55.3077 24.9097C55.3077 25.639 55.4575 26.1339 55.7571 26.3944C56.0566 26.6418 56.4929 26.7656 57.066 26.7656C57.2222 26.7656 57.3004 26.8177 57.3004 26.9219C57.3004 27.0391 57.2157 27.0977 57.0464 27.0977C56.8641 27.0977 56.5385 27.0847 56.0696 27.0586C55.6789 27.0195 55.3142 27 54.9756 27H54.1747C53.9663 27 53.6146 27.013 53.1197 27.0391C52.729 27.0781 52.3318 27.0977 51.9281 27.0977C51.8239 27.0977 51.7587 27.0847 51.7327 27.0586C51.6936 27.0326 51.6741 26.987 51.6741 26.9219C51.6741 26.8177 51.7522 26.7656 51.9085 26.7656C52.3644 26.7656 52.7225 26.72 52.983 26.6288C53.2565 26.5377 53.4649 26.3553 53.6081 26.0818C53.7514 25.8083 53.823 25.4176 53.823 24.9097V13.2078C53.823 12.6608 53.7644 12.3091 53.6472 12.1528C53.543 11.9966 53.3932 11.9184 53.1979 11.9184C52.8332 11.9184 52.3969 11.964 51.889 12.0552H51.8108C51.7197 12.0552 51.6741 12.0096 51.6741 11.9184C51.6741 11.8403 51.7587 11.7817 51.9281 11.7426C52.3057 11.6775 52.9114 11.4951 53.7449 11.1956C53.823 11.1695 54.0379 11.0979 54.3896 10.9807C54.7542 10.8505 55.0017 10.7853 55.1319 10.7853H55.1515C55.3468 10.7853 55.4445 10.9026 55.4445 11.137C55.4445 11.9835 55.425 12.8952 55.3859 13.872C55.3338 15.4609 55.3077 16.8154 55.3077 17.9354V24.9097ZM61.0793 27.3126C60.3239 27.3126 59.6467 27.0651 59.0476 26.5702C58.4485 26.0753 57.9796 25.4111 57.641 24.5776C57.3154 23.744 57.1526 22.8454 57.1526 21.8816C57.1526 20.8397 57.3089 19.902 57.6215 19.0685C57.934 18.235 58.3834 17.5773 58.9694 17.0954C59.5685 16.6005 60.2718 16.353 61.0793 16.353C61.8347 16.353 62.5119 16.6005 63.111 17.0954C63.7231 17.5903 64.192 18.2545 64.5176 19.088C64.8562 19.9216 65.0255 20.8202 65.0255 21.784C65.0255 22.8259 64.8692 23.7636 64.5567 24.5971C64.2441 25.4306 63.7882 26.0948 63.1892 26.5897C62.5901 27.0716 61.8868 27.3126 61.0793 27.3126ZM58.7545 20.5141C58.7545 21.53 58.8587 22.5328 59.0671 23.5226C59.2885 24.4994 59.6206 25.3069 60.0634 25.9451C60.5062 26.5832 61.0467 26.9023 61.6849 26.9023C62.2579 26.9023 62.6877 26.5377 62.9743 25.8083C63.2608 25.066 63.404 24.1869 63.404 23.171C63.404 22.1682 63.2933 21.1784 63.0719 20.2016C62.8505 19.2118 62.5184 18.3978 62.0756 17.7596C61.6458 17.1084 61.1184 16.7828 60.4932 16.7828C59.9071 16.7828 59.4709 17.154 59.1843 17.8964C58.8978 18.6257 58.7545 19.4983 58.7545 20.5141ZM73.6832 27.2149C73.618 27.2149 73.5594 27.1888 73.5073 27.1368C73.4552 27.0977 73.4162 27.0456 73.3901 26.9805L71.9445 21.0025C71.8924 20.7681 71.8273 20.6509 71.7491 20.6509C71.671 20.6509 71.5994 20.7681 71.5342 21.0025L69.8932 26.9805C69.8672 27.0456 69.8281 27.0977 69.776 27.1368C69.7239 27.1888 69.6653 27.2149 69.6002 27.2149H69.229C69.1639 27.2149 69.1053 27.1954 69.0532 27.1563C69.0011 27.1172 68.962 27.0651 68.936 27L66.5526 18.6973C66.3442 17.994 66.0838 17.5187 65.7712 17.2712C65.4586 17.0238 65.0809 16.9 64.6381 16.9C64.5209 16.9 64.4623 16.8544 64.4623 16.7633C64.4623 16.6982 64.4753 16.6526 64.5014 16.6265C64.5274 16.6005 64.573 16.5875 64.6381 16.5875C64.7684 16.5875 65.0158 16.6005 65.3805 16.6265C65.68 16.6656 65.96 16.6851 66.2205 16.6851H67.3341L68.2522 16.6656C68.669 16.6396 68.9816 16.6265 69.1899 16.6265L70.1081 16.6461C70.5249 16.6721 70.8505 16.6851 71.0849 16.6851H72.0617C72.3612 16.6851 72.7975 16.6721 73.3706 16.6461L74.6013 16.6265C74.8748 16.6265 75.2851 16.6396 75.8321 16.6656L76.9261 16.6851H76.9456C77.1019 16.6851 77.3884 16.6721 77.8052 16.6461C78.1178 16.607 78.4303 16.5875 78.7429 16.5875C78.8862 16.5875 78.9578 16.6396 78.9578 16.7437C78.9578 16.8479 78.8927 16.9 78.7625 16.9C78.2024 16.9 77.7596 17.0238 77.434 17.2712C77.1084 17.5056 76.848 17.981 76.6526 18.6973L74.3278 27C74.3018 27.0651 74.2627 27.1172 74.2106 27.1563C74.1585 27.1954 74.0999 27.2149 74.0348 27.2149H73.6832ZM69.8346 24.558C69.8997 24.7794 69.9779 24.8901 70.0691 24.8901C70.1602 24.8901 70.2319 24.7729 70.2839 24.5385L71.3975 20.3969C71.4496 20.1885 71.4756 19.9281 71.4756 19.6155C71.4756 19.2639 71.4431 18.9904 71.3779 18.795L71.2607 18.3457C71.1175 17.8768 70.9026 17.5187 70.6161 17.2712C70.3426 17.0238 69.8737 16.9 69.2095 16.9C68.7667 16.9 68.4476 16.9651 68.2522 17.0954C68.0699 17.2256 67.9787 17.434 67.9787 17.7205C67.9787 18.0071 68.0634 18.4238 68.2327 18.9708L69.8346 24.558ZM74.2888 24.5971C74.3539 24.8315 74.4255 24.9487 74.5037 24.9487C74.5688 24.9487 74.6339 24.838 74.699 24.6166L76.2423 19.0294C76.3465 18.7038 76.3986 18.3847 76.3986 18.0722C76.3986 17.6163 76.2489 17.3103 75.9493 17.154C75.6628 16.9847 75.2135 16.9 74.6013 16.9C73.9241 16.9 73.4422 16.9847 73.1557 17.154C72.8822 17.3233 72.7454 17.5708 72.7454 17.8964C72.7454 18.0657 72.778 18.2675 72.8431 18.502L74.2888 24.5971ZM81.4658 27.3126C80.7625 27.3126 80.1504 27.0912 79.6295 26.6484C79.1215 26.1925 78.7308 25.5674 78.4573 24.7729C78.1838 23.9655 78.0471 23.0408 78.0471 21.9989C78.0471 20.9179 78.1903 19.9541 78.4769 19.1076C78.7764 18.248 79.2127 17.5773 79.7858 17.0954C80.3718 16.6005 81.0686 16.353 81.8761 16.353C82.6054 16.353 83.211 16.5809 83.6929 17.0368C84.1878 17.4926 84.4353 18.0787 84.4353 18.795C84.4353 19.1466 84.3376 19.4397 84.1422 19.6741C83.9469 19.9085 83.7059 20.0257 83.4194 20.0257C83.1719 20.0257 82.9766 19.9606 82.8333 19.8304C82.7031 19.7002 82.638 19.5243 82.638 19.3029C82.638 19.1597 82.6836 18.9838 82.7747 18.7755C82.905 18.4889 82.9701 18.2219 82.9701 17.9745C82.9701 17.6229 82.8529 17.3298 82.6184 17.0954C82.384 16.8479 82.0779 16.7242 81.7003 16.7242C81.2314 16.7242 80.8342 16.9586 80.5086 17.4275C80.196 17.8833 79.9616 18.4629 79.8053 19.1662C79.649 19.8564 79.5709 20.5597 79.5709 21.276C79.5709 22.6826 79.7988 23.8287 80.2546 24.7143C80.7104 25.5999 81.3486 26.0427 82.1691 26.0427C82.6119 26.0427 83.0222 25.8474 83.3999 25.4567C83.7906 25.066 84.1422 24.4799 84.4548 23.6985C84.4808 23.6203 84.5069 23.5682 84.5329 23.5422C84.572 23.5031 84.6111 23.4836 84.6502 23.4836C84.7022 23.4836 84.7283 23.5096 84.7283 23.5617L84.6892 23.7571C84.3897 24.8511 83.9729 25.7172 83.4389 26.3553C82.918 26.9935 82.2603 27.3126 81.4658 27.3126ZM87.1774 27.3126C86.5392 27.3126 86.0313 27.0977 85.6536 26.6679C85.2759 26.2381 85.0871 25.6911 85.0871 25.0269C85.0871 24.1543 85.4583 23.4054 86.2006 22.7803C86.943 22.1421 87.9588 21.517 89.2482 20.9049C89.4696 20.8137 89.6519 20.6574 89.7952 20.436C89.9385 20.2146 90.0101 19.9802 90.0101 19.7327V19.4787C90.0101 18.4759 89.8603 17.7661 89.5608 17.3494C89.2612 16.9326 88.851 16.7242 88.33 16.7242C87.9133 16.7242 87.5942 16.8284 87.3728 17.0368C87.1514 17.2452 87.0407 17.5447 87.0407 17.9354C87.0407 18.1438 87.0928 18.4043 87.1969 18.7169C87.21 18.7559 87.236 18.8536 87.2751 19.0099C87.3142 19.1662 87.3337 19.3225 87.3337 19.4787C87.3337 19.7392 87.2555 19.9476 87.0993 20.1039C86.956 20.2472 86.7541 20.3188 86.4937 20.3188C86.1941 20.3188 85.9532 20.1951 85.7708 19.9476C85.6015 19.7001 85.5169 19.4006 85.5169 19.049C85.5169 18.541 85.6536 18.0787 85.9271 17.6619C86.2136 17.2452 86.5978 16.9196 87.0797 16.6851C87.5616 16.4507 88.1021 16.3335 88.7012 16.3335C89.5868 16.3335 90.2901 16.5875 90.8111 17.0954C91.332 17.5903 91.5925 18.3522 91.5925 19.3811C91.5925 20.0323 91.5795 21.009 91.5534 22.3114C91.5143 23.3012 91.4948 24.2845 91.4948 25.2613C91.4948 26.0037 91.7032 26.3749 92.1199 26.3749C92.3283 26.3749 92.5432 26.2316 92.7646 25.9451C92.986 25.6585 93.1879 25.1702 93.3702 24.4799C93.3833 24.4148 93.4028 24.3692 93.4288 24.3431C93.4549 24.3041 93.4874 24.2845 93.5265 24.2845C93.6177 24.2845 93.6437 24.3627 93.6047 24.519C93.3833 25.5088 93.1098 26.2251 92.7842 26.6679C92.4586 27.0977 92.0092 27.3126 91.4362 27.3126C91.0064 27.3126 90.6417 27.1823 90.3422 26.9219C90.0426 26.6484 89.8929 26.2642 89.8929 25.7692C89.8929 25.5609 89.9189 25.3525 89.971 25.1441L89.9906 25.0464C89.9906 24.9943 89.9775 24.9553 89.9515 24.9292C89.9254 24.9032 89.8994 24.8901 89.8733 24.8901C89.7691 24.8901 89.678 24.9618 89.5998 25.105C89.3133 25.6911 89.0593 26.1404 88.8379 26.453C88.6165 26.7525 88.3756 26.9674 88.1151 27.0977C87.8677 27.2409 87.5551 27.3126 87.1774 27.3126ZM86.5913 24.4604C86.5913 24.9292 86.6955 25.3134 86.9039 25.613C87.1253 25.8995 87.4444 26.0427 87.8612 26.0427C88.2388 26.0427 88.5905 25.8995 88.9161 25.613C89.2547 25.3264 89.5217 24.9292 89.7171 24.4213C89.9124 23.9134 90.0101 23.3468 90.0101 22.7217V21.6472C90.0101 21.4779 89.971 21.3477 89.8929 21.2565C89.8147 21.1523 89.7105 21.1002 89.5803 21.1002C89.4631 21.1002 89.3524 21.1263 89.2482 21.1784C87.477 22.064 86.5913 23.158 86.5913 24.4604ZM95.243 27C95.0347 27 94.67 27.013 94.149 27.0391C93.7583 27.0781 93.3546 27.0977 92.9378 27.0977C92.8336 27.0977 92.762 27.0847 92.7229 27.0586C92.6839 27.0326 92.6643 26.987 92.6643 26.9219C92.6643 26.8177 92.749 26.7656 92.9183 26.7656C93.3871 26.7656 93.7583 26.72 94.0318 26.6288C94.3053 26.5377 94.5137 26.3553 94.657 26.0818C94.8002 25.8083 94.8719 25.4176 94.8719 24.9097V18.7559C94.8719 18.2089 94.8198 17.8573 94.7156 17.701C94.6114 17.5447 94.4551 17.4666 94.2467 17.4666C93.843 17.4666 93.4132 17.5121 92.9574 17.6033H92.8792C92.788 17.6033 92.7425 17.5577 92.7425 17.4666C92.7425 17.4145 92.762 17.3819 92.8011 17.3689C92.8271 17.3428 92.8922 17.3168 92.9964 17.2907C93.3741 17.2256 93.9732 17.0433 94.7937 16.7437C94.8719 16.7177 95.0867 16.6461 95.4384 16.5289C95.8031 16.3986 96.057 16.3335 96.2003 16.3335C96.3956 16.3335 96.4933 16.4507 96.4933 16.6851C96.4933 16.8414 96.4803 17.1019 96.4542 17.4666V17.5838C96.4542 17.7791 96.4998 17.8768 96.591 17.8768C96.6822 17.8768 96.7864 17.8052 96.9036 17.6619C97.3073 17.2191 97.698 16.887 98.0757 16.6656C98.4664 16.4442 98.8116 16.3335 99.1111 16.3335C99.4758 16.3335 99.7883 16.4377 100.049 16.6461C100.322 16.8414 100.57 17.1279 100.791 17.5056C100.921 17.7531 101.078 17.8768 101.26 17.8768C101.416 17.8768 101.56 17.7987 101.69 17.6424C102.51 16.7698 103.233 16.3335 103.858 16.3335C104.549 16.3335 105.063 16.5744 105.402 17.0563C105.753 17.5252 105.929 18.1959 105.929 19.0685V24.9097C105.929 25.639 106.092 26.1339 106.417 26.3944C106.743 26.6418 107.225 26.7656 107.863 26.7656C108.032 26.7656 108.117 26.8177 108.117 26.9219C108.117 27.0391 108.026 27.0977 107.844 27.0977C107.635 27.0977 107.271 27.0847 106.75 27.0586C106.346 27.0195 105.949 27 105.558 27H104.718C104.483 27 104.171 27.013 103.78 27.0391L102.882 27.0586H102.862H102.842C102.621 27.0586 102.289 27.0456 101.846 27.0195L100.889 27H99.9707C99.7362 27 99.4237 27.013 99.033 27.0391L98.1343 27.0586H98.0952H98.0366C97.8152 27.0586 97.4831 27.0456 97.0403 27.0195L96.0831 27H95.243ZM96.2003 16.3335H96.1807H96.2003ZM96.3566 24.6166C96.3566 25.3981 96.4673 25.9581 96.6887 26.2967C96.9101 26.6223 97.3594 26.7851 98.0366 26.7851H98.0952H98.1343C98.7464 26.7851 99.1567 26.6223 99.3651 26.2967C99.5735 25.9711 99.6776 25.4111 99.6776 24.6166V19.088C99.6776 18.515 99.5669 18.0982 99.3455 17.8377C99.1372 17.5642 98.7985 17.4275 98.3297 17.4275C98.1213 17.4275 97.8608 17.4861 97.5482 17.6033C97.2357 17.7075 96.9557 17.8964 96.7082 18.1699C96.4738 18.4303 96.3566 18.782 96.3566 19.2248V24.6166ZM101.182 24.6166C101.182 25.1506 101.221 25.5674 101.299 25.8669C101.39 26.1665 101.553 26.3944 101.788 26.5507C102.022 26.707 102.374 26.7851 102.842 26.7851H102.862H102.882C103.494 26.7851 103.904 26.6223 104.112 26.2967C104.321 25.9711 104.425 25.4111 104.425 24.6166V19.088C104.425 18.515 104.314 18.0982 104.093 17.8377C103.884 17.5642 103.546 17.4275 103.077 17.4275C102.855 17.4275 102.595 17.4796 102.295 17.5838C101.996 17.688 101.735 17.8638 101.514 18.1112C101.293 18.3457 101.182 18.6517 101.182 19.0294V24.6166Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_diii_141_259",
    x: 0.217391,
    y: 0.913043,
    width: 37.5652,
    height: 37.5652,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.695652
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.3913
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_141_259"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_141_259",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.86957
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_141_259"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.695652,
    dy: -2.08696
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.695652
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_141_259",
    result: "effect3_innerShadow_141_259"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.695652,
    dy: 1.3913
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.695652
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow_141_259",
    result: "effect4_innerShadow_141_259"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_df_141_259",
    x: 5.07481,
    y: 5.55742,
    width: 27.8504,
    height: 28.0634,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.695652
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.3913
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_141_259"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_141_259",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.15,
    result: "effect2_foregroundBlur_141_259"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dfn_141_259",
    x: 5.07481,
    y: 5.55742,
    width: 27.8504,
    height: 28.0634,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.695652
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.3913
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_141_259"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_141_259",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.15,
    result: "effect2_foregroundBlur_141_259"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "10 10",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 2646
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "effect2_foregroundBlur_141_259",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(0, 0, 0, 0.2)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect3_noise_141_259"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "effect2_foregroundBlur_141_259"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_141_259",
    x1: 30.1426,
    y1: 7.85742,
    x2: 7.85742,
    y2: 30.1426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_141_259",
    x1: 30.1426,
    y1: 7.85742,
    x2: 13,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D44610"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D44610",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_141_259",
    x1: 30.1426,
    y1: 7.85742,
    x2: 7.85742,
    y2: 30.1426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_141_259",
    x1: 30.1426,
    y1: 7.85742,
    x2: 13,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D44610"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D44610",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e18bbcd379e63d771445a09bb747a01d.svg";
export { ForwardRef as ReactComponent };